import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { hasUserIdentity } from './user-identity';

/*
PLATFORM-SEC03 (F02/F03): pantalla de aterrizaje del usuario SIN ROL.

Antes de este componente, un usuario sin rol (tipicamente auto-provisionado por SSO cuando su
grupo de AD no matchea ningun rol de Prisma) quedaba en PANTALLA EN BLANCO: PrismaCanActivateRoute
devolvia false y la navegacion se cancelaba sin redirigir a ningun lado.

Renderiza DENTRO del shell (vertical-layout-1), asi el usuario conserva los controles del toolbar
(cerrar sesion y cambio de idioma), que sobreviven al vaciado del menu principal de DES-486.

Los datos de perfil salen del token (getUserData), sin consulta al backend. NO se lo manda a
/admin/profile/info/data: esa ruta cuelga de la rama `admin` del ruteo y exige el permiso
`admin_view`, que un usuario sin rol no tiene.

Esta pantalla NO esta gateada por configuracion: aplica a todos los clientes (ver F06 del spec).
*/
@Component({
  selector: 'app-no-role',
  templateUrl: './no-role.component.html',
  styleUrls: ['./no-role.component.scss'],
})
export class NoRoleComponent implements OnInit {
  username = '';
  fullName = '';
  email = '';
  // Esta ruta no tiene guards (ver app-routing): sin sesion (pantalla de login) no se muestra el aviso.
  isLogged = false;

  constructor(private oidcSecurityService: OidcSecurityService) {}

  ngOnInit(): void {
    this.oidcSecurityService.getUserData().subscribe((data: any) => {
      // Mismo criterio de identidad que PrismaCanActivateRoute / UnauthorizedComponent.
      this.isLogged = hasUserIdentity(data);
      if (!this.isLogged) return;

      this.username = data.name || data.preferred_username || '';
      this.fullName = [data.given_name, data.family_name].filter(Boolean).join(' ');
      this.email = data.email || '';
    });
  }

  get hasAnyData(): boolean {
    return Boolean(this.username || this.fullName || this.email);
  }
}
